import { goBack } from "connected-react-router";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import { isEmpty } from "lodash";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import { ResponsiveHeader } from "pages/_components/header";
import I18n from "pages/_components/I18n";
import Loader from "pages/_components/Loader";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { actions as echeckActions } from "reducers/echecks";
import SummaryActions from "../components/SummaryActions";
import ReturnSummaryBody from "./ReturnSummary";

const AcceptReturnPage = () => {
    const { echeqsToDoActions: echeqAction } = useSelector((state) => state.echecks);
    const { echeckTicket } = useSelector((state) => state.echecks);
    const { dispatch } = useConfirmTransaction(echeqAction, echeckTicket, "echecks/return");

    useEffect(() => {
        if (isEmpty(echeqAction)) {
            dispatch(goBack());
        }
    }, [dispatch]);

    if (isEmpty(echeqAction)) {
        return <Loader />;
    }

    return (
        <>
            <Notification scopeToShow="echecks/return" />
            <ResponsiveHeader id="echecks.acceptRetun" />
            <MainContainer>
                <I18n id="echecks.summary.confirm" />
                {echeqAction?.echeqList?.length > 1 && <SummaryActions list={echeqAction?.echeqList} currency="ARS" />}
                <ReturnSummaryBody echeqList={echeqAction?.echeqList} solicitantName={echeqAction?.solicitantName} />
                <GeneralCredentialForm
                    transactionData={{ echeqAction }}
                    action={echeckActions.acceptReturnEcheq}
                    idActivity="accept.return.echeqs"
                />
            </MainContainer>
        </>
    );
};

export default AcceptReturnPage;
